import {TrainingPlanProvider as TrainingPlanSelectorWithInitialDataPresenterTrainingPlanProvider} from '../ui/TrainingPlanSelectorWithInitialDataPresenter';
import {TrainingPlanProvider as TrainingPlanSearchModalPresenterTrainingPlanProvider} from '../ui/TrainingPlanSearchModal/TrainingPlanSearchModalPresenter';
import {TrainingPlan} from '../models/TrainingPlan';

export class DefaultTrainingPlanProvider
    implements
        TrainingPlanSelectorWithInitialDataPresenterTrainingPlanProvider,
        TrainingPlanSearchModalPresenterTrainingPlanProvider
{
    constructor(private trainingPlans: TrainingPlan[]) {}

    public async get(): Promise<TrainingPlan[]> {
        //TODO consider if an ajax call is needed here
        return this.trainingPlans;
    }
}
